import { useEffect, useState } from "react";
import Announce from "./Announce";

import "./Clock.css";
import unknown from "./img/raw/texture_unknown1.png";
import sunny from "./img/raw/texture_sun4.png";
import cloudy from "./img/raw/texture_cloud.png";
import partlycloudy from "./img/raw/texture_partcloud2.png";
import rainy from "./img/raw/texture_drop.png";
import snowy from "./img/raw/texture_snow.png";
import stormy from "./img/raw/texture_storm3.png";
import foggy from "./img/raw/texture_fog1.png";

const dayArray = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

function ParseOpenWeatherRes(weatherObj) {
  // Check to see if valid
  if (!weatherObj || weatherObj["weather"] === undefined) return false;

  const weather = weatherObj.weather[0];

  console.log(weather);

  switch (weather.main) {
    case "Thunderstorm":
    case "Squall":
    case "Tornado":
      return "stormy";
    case "Drizzle":
    case "Rain":
    case "Mist":
      return "rainy";
    case "Snow":
      return "snowy";
    case "Smoke":
    case "Haze":
    case "Dust":
    case "Fog":
    case "Sand":
    case "Dust":
    case "Ash":
      return "foggy";
    case "Clouds":
      if (weather.id === 801 || weather.id === 802) return "partlycloudy";
      else return "cloudy";
    default:
      return "sunny";
  }
}

export default function Clock() {
  const initDate = new Date();
  const [hr, setHr] = useState(initDate.getHours());
  const [min, setMin] = useState(initDate.getMinutes());
  const [sec, setSec] = useState(initDate.getSeconds());
  const [day, setDay] = useState(dayArray[initDate.getDay()]);
  const [weather, setWeather] = useState("unset");

  useEffect(() => {
    setInterval(() => {
      const now = new Date();
      setHr(now.getHours());
      setMin(now.getMinutes());
      setSec(now.getSeconds());
      setDay(dayArray[now.getDay()]);
    }, 1000);

    if (weather === "unset") {
      const lat = 40.7674;
      const lon = -74.0323;
      const appID = "d6b4073c08ed3135d0945a290ab40df3";
      fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${appID}`
      )
        .then((res) => res.json())
        .then((json) => {
          setWeather(ParseOpenWeatherRes(json));
        })
        .catch((error) => console.error(error));
    }
  });

  return (
    <div>
      <div className="datetime">
        <div className="day">{day}</div>
        <div className="time">
          {hr % 12 !== 0 ? hr % 12 : "12"}:{String(min).padStart(2, "0")}:
          {String(sec).padStart(2, "0")} {hr < 12 ? "AM" : "PM"}
        </div>
      </div>
      <Announce hr={hr} min={min} day={day} weather={weather} />

      <img
        src={
          weather === "sunny"
            ? sunny
            : weather === "stormy"
            ? stormy
            : weather === "rainy"
            ? rainy
            : weather === "snowy"
            ? snowy
            : weather === "foggy"
            ? foggy
            : weather === "partlycloudy"
            ? partlycloudy
            : weather === "cloudy"
            ? cloudy
            : unknown
        }
        alt={`current weather is ${weather}`}
      />
      <div style={{ display: "none" }}>
        <img src={sunny} />
        <img src={stormy} />
        <img src={rainy} />
        <img src={snowy} />
        <img src={foggy} />
        <img src={partlycloudy} />
        <img src={cloudy} />
        <img src={unknown} />
      </div>
    </div>
  );
}
